import { createStore } from "owa-satcheljs";
import type { AccountKey } from "owa-client-types";
import type { BizChatCompositeKey } from "owa-bizchat-types";
import type { UserCohort } from "owa-bizchat-types/lib/UserCohort";

export interface BizchatSidepaneEnabledSettings {
    hasAcquisition: boolean;
    userCohort: UserCohort;
    isCopilotEligible: boolean;
}

interface BizchatSidepaneStore {
    // <key: Coprincipal Account Identifier, value: Bizchat Acquisition Settings>
    hasBizchatAcquisitionMap: Map<AccountKey, BizchatSidepaneEnabledSettings>;
    isBizchatSidepaneLoadedMap: Map<BizChatCompositeKey, boolean>;
    isPrecacheComplete: boolean;
}

export const bizchatSidepaneStore: () => BizchatSidepaneStore = createStore<BizchatSidepaneStore>("BizchatSidepaneStore", {
    hasBizchatAcquisitionMap: new Map<AccountKey, BizchatSidepaneEnabledSettings>(),
    isBizchatSidepaneLoadedMap: new Map<BizChatCompositeKey, boolean>(),
    isPrecacheComplete: false,
});
